var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatvBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4,
    fill: "#6856DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3469 25.5168V28.4332C14.3469 30.7728 16.2106 32.6689 18.5102 32.6689C20.8098 32.6689 22.6735 30.7728 22.6735 28.4332V13.2357C22.6735 10.8961 24.5371 9 26.8367 9C29.1363 9 31 10.8961 31 13.2357V22.2677",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.6618H18.8163V21.914C18.8163 23.8974 17.2343 25.5069 15.2849 25.5069H13.5314C11.582 25.5069 10 23.8974 10 21.914V16.6618Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5305 12.9242H11.2856V16.6616H17.5305V12.9242Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 10.3817L14.2 12.4817",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatvBlueBg);
export default __webpack_public_path__ + "static/media/CATVBlueBG.990f07aa3bf831b4e4ba6c444b8eec65.svg";
export { ForwardRef as ReactComponent };